import { render, staticRenderFns } from "./DashboardRemoveCampaign.vue?vue&type=template&id=11fe89e8&"
import script from "./DashboardRemoveCampaign.vue?vue&type=script&lang=js&"
export * from "./DashboardRemoveCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports